import { NgModule, ModuleWithProviders } from '@angular/core';

import { JZAuthRoutingModule } from './jz-auth-routing.module';

import { JZAuthModuleConfig } from './jz-auth-module-config.service';
import { NzSpinModule } from 'ng-zorro-antd/spin';

import { JZCallbackPageComponent } from './jz-callback-page.component';
import { JZLoginPageComponent } from './jz-login-page.component';

const COMPONENTS = [
  JZCallbackPageComponent,
  JZLoginPageComponent,
];

const COMPONENTS_NOROUNT = [];

@NgModule({
  imports: [JZAuthRoutingModule,NzSpinModule],
  declarations: [...COMPONENTS, ...COMPONENTS_NOROUNT],
  entryComponents: COMPONENTS_NOROUNT,
})
export class JZAuthModule {
  static forRoot(config: JZAuthModuleConfig): ModuleWithProviders<JZAuthModule> {
    return {
      ngModule: JZAuthModule,
      providers: [
        { provide: JZAuthModuleConfig, useValue: config }
      ]
    };
  }
}
